<template>
  <div :class="classes()">
    <!-- Status: {{ userStatus }} -->

    <div :class="`${el}__widgets`">
      <div :class="`${el}__widgetRow`">
        <Row>
          <Col :xs="12">
            <CareProfilesWidget @onTrackingClick="trackClick" />
          </Col>
        </Row>
      </div>

      <div :class="`${el}__widgetRow`">
        <Row>
          <Col :xs="12">
            <TaskSchedulerWidget @onTrackingClick="trackClick" />
          </Col>
        </Row>
      </div>

      <Headline :staticClass="`${el}__subHeadline`" size="s" isSubheading responsive>
        {{ $t('dashboard.subHeading1') }}
      </Headline>

      <div :class="`${el}__widgetRow`">
        <Row>
          <Col :xs="12" :l="6">
            <CareLevelAnalysisWidget @onTrackingClick="trackClick" />
          </Col>
          <Col :xs="12" :l="6" :class="`${el}--hasMargin`">
            <ApplicationsWidget @onTrackingClick="trackClick" />
          </Col>
        </Row>
      </div>

      <div :class="`${el}__widgetRow`">
        <Row>
          <Col :xs="12">
            <PflegeleistungsfinderWidget @onTrackingClick="trackClick" />
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTE_SERVICE_PFLEGELEISTUNGSFINDER } from '@/constants/routes';
import Headline from '@/objects/Headline';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';
import { TaskSchedulerWidget } from '@/views/TaskScheduler';
import { ApplicationsWidget } from '@/views/Applications';
import CareLevelAnalysisWidget from '@/views/CareLevelCalculator/Analysis/AnalysisWidget';
import { PflegeleistungsfinderWidget } from '@/views/Pflegeleistungsfinder';
import { CareProfilesWidget } from '@/views/CareProfiles';
import { createTrackingData } from '@/helpers/tracking/utils/helpers';
import { mapFieldsContentSheet } from '@/store/mapFields';

export default {
  name: 'Dashboard',
  components: {
    Headline,
    CareProfilesWidget,
    Row,
    Col,
    TaskSchedulerWidget,
    ApplicationsWidget,
    CareLevelAnalysisWidget,
    PflegeleistungsfinderWidget,
  },
  props: {},
  title() {
    return 'Dashboard';
  },

  beforeRouteLeave(to, from, next) {
    setInterval(() => {
      next();
    }, 10);
  },

  computed: {
    ...mapFieldsContentSheet(['contentSheetIsOpen']),
  },

  data() {
    return {
      ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
      el: 'v-dashboard',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },

  methods: {
    trackClick(labelText, element = 'button') {
      const product = 'Dashboard';
      const label = product + labelText;

      createTrackingData(product, label, element);
    },
  },
};
</script>
